import { Grid } from '@mui/material';
import React, { useState } from 'react';
import TabSelector from './TabSelector';
import Sections from '../sections/Sections';
import './DesktopTabbedSection.scss';
import { Tab } from './TabbedSection';

function DesktopTabbedSection() {
  const [selectedTab, setSelectedTab] = useState<Tab>(
    Tab.REGISTRATION_AND_ATTENDANCE
  );

  return (
    <div className="tab-container">
      <Grid direction="row" container>
        <Grid item xs={4}>
          <TabSelector selectedTab={selectedTab} selectTab={setSelectedTab} />
        </Grid>
        <Grid item xs={8}>
          <Sections selectedSection={selectedTab} />
        </Grid>
      </Grid>
    </div>
  );
}

export default DesktopTabbedSection;
